import types from '../types';

const posts = (
  state = {
    loading: true,
    data: null,
    single: null,
    categories: null,
    singleCategory: null,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_POSTS_START:
    case types.GET_SINGLE_POST_START:
    case types.GET_CATEGORIES_START:
    case types.GET_SINGLE_CATEGORY_START:
      return {
        ...state,
        single: null,
        categories: null,
        singleCategory: null,
        loading: true,
      };

    case types.GET_POSTS_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_POSTS_FAILURE:
    case types.GET_SINGLE_POST_FAILURE:
    case types.GET_CATEGORIES_FAILURE:
    case types.GET_SINGLE_CATEGORY_FAILURE:
      return { ...state, loading: false };

    case types.GET_SINGLE_POST_SUCCESS:
      return { ...state, single: payload, loading: false };

    case types.GET_CATEGORIES_SUCCESS:
      return { ...state, categories: payload, loading: false };

    case types.GET_SINGLE_CATEGORY_SUCCESS:
      return { ...state, singleCategory: payload, loading: false };

    case types.DELETE_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          posts: state.data.posts.filter(post => post.post_id !== +payload),
        },
      };

    case types.DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: {
          ...state.categories,
          categories: state.categories.categories.filter(
            category => category.category_id !== +payload,
          ),
        },
      };

    default:
      return state;
  }
};

export default posts;
